// extracted by mini-css-extract-plugin
module.exports = {"iwgb":"Footer_iwgb__3i-br","itf":"Footer_itf__2qNUN","policyLink":"Footer_policyLink__3Wxd-"};